import {
  Json,
  LoadingContainer,
  Modal,
  Input,
  NumericInput,
  Select,
  Button,
  Model,
} from 'peach/components'
import { PersonCaseSelect } from 'peach/data'
import { useParams } from 'peach/router'

import { useInternalLoanScheduleDefer } from 'core/types'

import ScheduleTable from './ScheduleTable'

const DeferScheduleForm = ({ value }) => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    mutateAsync: previewDeferSchedule,
    isPending: sending,
    data: resp,
    error,
  } = useInternalLoanScheduleDefer({
    companyId,
    personId,
    loanId,
  })

  const sendPreview = async () => {
    await previewDeferSchedule({
      previewMode: true,
      ...value,
    })
  }

  const { schedule, ...rest } = resp || {}

  return (
    <>
      <Modal.Page page='Options'>
        <NumericInput
          formKey='bufferToPushOutSchedule'
          note={`When deferring during the first period, this represents the number of calendar days that will be added to today's date. The resulting date will be used to push out due dates (today's date + buffer days). Interest  will continue to accrue. 

            When deferring after the first period, we defer all due dates that fall in the period of "today's date" and "today's date + buffer days" to the end of the loan one by one.`}
        />
        <Input
          formKey='agreementDocumentId'
          note={`The document desciptor ID corresponding to the accepted loan term change agreement. This is required unless 'previewMode=true' or 'isShowRevisedTermsOnFrequencyChange=false' on the loan type.`}
        />

        <Select boolean formKey='waiveFee' />

        <PersonCaseSelect formKey='caseId' />
      </Modal.Page>
      <Modal.Page page='Preview'>
        <LoadingContainer error={error} loading={sending}>
          <Json.Table json={value} title='Defer Options' />
          <Button onClick={sendPreview}>Preview</Button>
          <Model.Item json={rest} title='Defer Preview Results' />
          <ScheduleTable schedule={schedule} />
        </LoadingContainer>
      </Modal.Page>
    </>
  )
}

export default DeferScheduleForm
